import { observer } from 'mobx-react-lite'
import { useInjection } from '@core/providers/inversify-react.provider'
import { AppPresenter } from '@app/app.presenter'

// Global route-transition indicator — mounted once above both the bare and
// app shells, so it shows during navigation regardless of which one the
// destination route uses (including into/out of a bare page like Login).
export const RouteProgressBarComponent = observer(() => {
  const presenter: AppPresenter = useInjection(AppPresenter)

  if (!presenter.isLoading) return null

  return <div className="fixed inset-x-0 top-0 z-50 h-0.5 animate-pulse bg-shell-accent" />
})
